import { firebind, withUserId } from './database'

export default (Component) => withUserId(firebind(Component, {profile: ({userId}) => `users/${userId}/profile`}))